module.exports = __webpack_public_path__ + "static/media/selfApplyCode.ec01fedc.svg";